import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "components";
import Breadcrumb from "components/molecules/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "actions";
import { API_URL_ticketStatus } from "constants/api";
import { ticketStatusReducers } from "redux/ticketStatusSlice";
import { FaEdit } from "react-icons/fa";
import { AuthContext } from "context/AuthContext";

const TABLE_HEAD = ["Nama", "Display order", "Actions"];

const Status = () => {
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const dispatch = useDispatch();

  const { getTicketStatusResult, addTicketStatusResult } = useSelector(
    (state) => state.ticketStatus
  );

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_ticketStatus,
        params,
        { dispatch, redux: ticketStatusReducers },
        "GET_TICKETSTATUS"
      );
    },
    [dispatch]
  );

  const onEdit = (item) => {
    navigate(`/administrator/tickets/status/edit`, {
      state: {
        item,
      },
    });
  };

  const action = [
    {
      name: "Edit Details",
      icon: <FaEdit />,
      func: onEdit,
      colorlight: "bg-sky-500",
      colordark: "dark:bg-sky-800",
      hoverlight: "hover:bg-sky-600",
      hoverdark: "hover:dark:bg-sky-900",
    },
  ];

  const fetchData = useCallback(() => {
    const params = ``;
    get(params);
  }, [get]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (addTicketStatusResult) {
      fetchData();
    }
  }, [addTicketStatusResult, fetchData]);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Settings"}
        excludedPaths={["tickets", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
          List of status
        </div>

        {/* <CardContainer title="List of agents"> */}
        <div className="m-4">
          <div className="overflow-x-auto min-h-[55vh]">
            <table className="border border-collapse items-center w-full">
              <thead className="text-left">
                <tr>
                  {TABLE_HEAD.map((head) => (
                    <th
                      key={head}
                      className="border border-blue-gray-100 bg-blue-gray-50 p-4"
                    >
                      {head}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {getTicketStatusResult &&
                  getTicketStatusResult.map((item, index) => (
                    <tr key={index}>
                      <td className="p-4 border border-blue-gray-50 w-4/12">
                        {item.name}
                      </td>
                      <td className="p-4 border border-blue-gray-50 w-4/12">
                        {item.sort}
                      </td>
                      <td className="p-4 border border-blue-gray-50">
                        {action.map((action, actionIdx) => (
                          <button
                            key={actionIdx}
                            className={`mx-0.5 text-white text-sm ${action.colorlight} ${action.colordark} ${action.hoverlight} ${action.hoverdark} rounded p-1 `}
                            onClick={() => action.func(item)}
                          >
                            <div className="flex items-center">
                              {action.icon} {action.name}
                            </div>
                          </button>
                        ))}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="pt-5 py-11"></div>
        </div>
        {/* </CardContainer> */}
      </div>
    </Container>
  );
};

export default Status;
